import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GenerateTicketInterface {
  ticketName: string;
  phoneNumber: string;
}

export const useGenerateTickets = () => {
  const mutate = useMutation(({ ticketName, phoneNumber }: GenerateTicketInterface) => {
    return postAPI('/enterprise-tickets-api/generate_tickets', {
      ticket_name: ticketName,
      phoneNumber,
    });
  });

  return mutate;
};

export default useGenerateTickets;
